import React from 'react';

// Geist 500 outlines of "Aero" (and "A" for the mark), from the brand files
// (docs/brand/logo, research/web3/shared/lockup.svg and mark.svg). The letters
// take currentColor, so the logo follows the text colour of its theme; the dot
// is always the Aero blue (--aero-blue).
const LETTERS_LOCKUP = 'M20 0 276 -710H413L669 0H554L489 -185H199L135 0ZM233 -283H456L344 -607Z M951 12Q873 12 816.5 -22Q760 -56 729.5 -119Q699 -182 699 -266Q699 -350 729.5 -412.5Q760 -475 816 -509.5Q872 -544 948 -544Q1020 -544 1075 -510.5Q1130 -477 1160.5 -414Q1191 -351 1191 -262V-235H809Q813 -157 850.5 -118Q888 -79 952 -79Q999 -79 1030 -101Q1061 -123 1073 -160L1183 -153Q1162 -79 1100.5 -33.5Q1039 12 951 12ZM809 -315H1079Q1074 -386 1038.5 -420Q1003 -454 948 -454Q891 -454 854.5 -418.5Q818 -383 809 -315Z M1286 0V-532H1383L1387 -391L1378 -394Q1389 -466 1422.5 -499Q1456 -532 1513 -532H1564V-437H1513Q1473 -437 1446 -424Q1419 -411 1405.5 -384Q1392 -357 1392 -314V0Z M1847 12Q1771 12 1714 -22Q1657 -56 1626 -119Q1595 -182 1595 -266Q1595 -351 1626 -413Q1657 -475 1714 -509.5Q1771 -544 1847 -544Q1923 -544 1980 -509.5Q2037 -475 2068 -413Q2099 -351 2099 -266Q2099 -182 2068 -119Q2037 -56 1980 -22Q1923 12 1847 12ZM1847 -80Q1915 -80 1952 -129.5Q1989 -179 1989 -266Q1989 -353 1952 -402.5Q1915 -452 1847 -452Q1780 -452 1742.5 -402.5Q1705 -353 1705 -266Q1705 -179 1742.5 -129.5Q1780 -80 1847 -80Z';
const LETTER_MARK = 'M20 0 276 -710H413L669 0H554L489 -185H199L135 0ZM233 -283H456L344 -607Z';

const VARIANTS = {
  lockup: { viewBox: '20 -710 2288.2 722', d: LETTERS_LOCKUP, cx: 2234.2 },
  mark: { viewBox: '20 -710 839.5 714', d: LETTER_MARK, cx: 785.5 },
};

/**
 * AeroLogo: the "Aero." lockup (default) or the "A." mark.
 * Size it with CSS height (e.g. .aero-logo-md) or the `height` prop.
 */
export default function AeroLogo({ variant = 'lockup', size = 'md', className = '', title = 'Aero' }) {
  const v = VARIANTS[variant] || VARIANTS.lockup;
  return (
    <svg
      className={`aero-logo aero-logo-${variant} aero-logo-${size} ${className}`.trim()}
      viewBox={v.viewBox}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path className="aero-logo-letters" d={v.d} />
      <circle className="aero-logo-dot" cx={v.cx} cy="-70" r="74" />
    </svg>
  );
}
